export const CALL_INDEX = 'CALL_INDEX'
export const CALL_SAVE = 'CALL_SAVE'



// WEBPACK FOOTER //
// ./src/store/actions/call.js